import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { FormGroup, TextField, Label, Toggle } from '@celltrak/ui-components';

import { profileForm } from '../../constants';

import styles from './ProfileFormFields.module.scss';

const ProfileFormFields = ({ handleToggleChange, handleAgencyNameChange, values }) => (
  <div className={styles.fieldsContainer}>
    <FormGroup>
      <div>
        <Toggle
          id={profileForm.statusToggleId}
          label={profileForm.statusToggleLabel}
          checked={values.active}
          onChange={event => handleToggleChange(event.target.checked)}
        />
      </div>
    </FormGroup>
    <FormGroup>
      <Label size="sm" for={profileForm.agencyNameId} required>
        {profileForm.agencyNameLabel}
      </Label>
      <TextField
        size="sm"
        id={profileForm.agencyNameId}
        value={values.agencyName}
        onChange={event => handleAgencyNameChange(event.target.value)}
      />
    </FormGroup>
  </div>
);

ProfileFormFields.propTypes = {
  handleToggleChange: PropTypes.func,
  handleAgencyNameChange: PropTypes.func,
  values: PropTypes.shape({
    active: PropTypes.bool,
    agencyName: PropTypes.string,
  }),
};

ProfileFormFields.defaultProps = {
  handleToggleChange: noop,
  handleAgencyNameChange: noop,
  values: {},
};

export default ProfileFormFields;
